import React, { createContext, useContext, ReactNode, useEffect, useState } from 'react';

declare global {
  interface Window {
    YocoSDK: any;
  }
}

interface YocoContextType {
  yoco: any;
  isLoaded: boolean;
}

const YocoContext = createContext<YocoContextType | undefined>(undefined);

export const useYoco = () => {
  const context = useContext(YocoContext);
  if (context === undefined) {
    throw new Error('useYoco must be used within a YocoProvider');
  }
  return context;
};

interface YocoProviderProps {
  children: ReactNode;
}

export const YocoProvider: React.FC<YocoProviderProps> = ({ children }) => {
  const [yoco, setYoco] = useState<any>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Load Yoco SDK
    const script = document.createElement('script');
    script.src = 'https://js.yoco.com/sdk/v1/yoco-sdk-web.js';
    script.async = true;
    script.onload = () => {
      if (window.YocoSDK) {
        const yocoInstance = new window.YocoSDK({
          publicKey: process.env.REACT_APP_YOCO_PUBLIC_KEY || '',
        });
        setYoco(yocoInstance);
        setIsLoaded(true);
      }
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const value: YocoContextType = {
    yoco,
    isLoaded
  };

  return (
    <YocoContext.Provider value={value}>
      {children}
    </YocoContext.Provider>
  );
};